import React from 'react';
import { IdentityVerificationContainer } from '../../../../../containers';

export const IdentityVerification = () => <IdentityVerificationContainer />;
